/* reveal.js — animaciones de entrada al hacer scroll (26-ago, pedido de Robert).

   Cada pieza de contenido (titulares, párrafos, botones, cards, fotos) entra
   con un fundido y un empujón de 22px hacia arriba cuando asoma en pantalla.
   Dentro de una misma sección van escalonadas, así que la sección se "monta"
   en vez de aparecer de golpe.

   Decisiones que importan:

   - El estado oculto lo pone ESTE script (clase `.reveal`), no el CSS a secas.
     Sin JS no se esconde nada: la página se ve entera, como hasta ahora.

   - Se anima con las propiedades sueltas `translate` y `scale`, NO con
     `transform`. Media docena de elementos del theme ya usan `transform` en su
     :hover (las cards suben 3px, los botones 2) y una transición sobre la misma
     propiedad desde dos sitios se pisa — es el mismo problema que documenta el
     CLAUDE.md con GSAP. Al ser propiedades distintas, el hover y la entrada
     conviven sin tocarse.

   - Lo que vive dentro de un carrusel NO se anima pieza a pieza: se anima el
     contenedor entero. Un slide oculto (`visibility:hidden`, `opacity:0`) nunca
     "intersecta", así que su contenido se quedaría invisible para siempre al
     rotar hacia él. Por eso `.most-popular__stage`, `.our-production__band`,
     `.shop-categories__main` y `.photo-mosaic__track` entran como bloque y sus
     tripas quedan excluidas.
     El mosaico del local lo enseñó en vivo: con las tiles animadas una a una,
     las 4 que esperan fuera del recuadro nunca intersecan, así que llegaban a
     su turno con opacity 0 y se revelaban a destiempo, a mitad de la rotación.
     Medido: 4 de 8 quedaban sin revelar tras recorrer la página entera.

   - El hero queda fuera del todo: tiene su propia intro con GSAP
     (`hero-anim.js`) y dos animaciones sobre los mismos nodos se estorban.

   - Red de seguridad, igual que hero-anim.js: si algo falla (sin
     IntersectionObserver, una pestaña que estuvo en segundo plano, un
     observador que no llega a disparar), a los 4s se revela todo lo que quede
     pendiente. Nunca se puede quedar contenido invisible por culpa de esto.

   - En el editor de temas, `shopify:section:load` re-inicializa la sección que
     Shopify acaba de repintar: si no, la sección recién editada entraría con
     el estado oculto y sin observador. */
(function () {
  var LISTA = [
    /* Bloques de cabecera y texto */
    '.section-heading',
    '.ocean__head',
    '.beef-anatomy__content > *',
    '.facility__text > *',
    '.testimonials__aggregate',
    '.testimonials__cta-wrap',
    /* Cards y piezas repetidas */
    '.pcard',
    '.testimonials__card',
    '.team-grid__item',
    '.instagram__item',
    '.instagram__cta-wrap',
    /* Bloques que entran como unidad (llevan carrusel o rotador dentro) */
    '.our-production__band',
    '.most-popular__head',
    '.most-popular__stage',
    '.shop-categories__aside',
    '.shop-categories__main',
    '.photo-mosaic__track',
    '.photo-mosaic__pagination',
    '.beef-anatomy__panel',
    '.facility__media',
    /* About Us */
    '.about-heritage__text > *',
    '.about-heritage__media',
    '.about-sourcing__text > *',
    '.about-sourcing__media',
    '.about-value',
    '.about-member',
    '.about-timeline__row',
    '.about-quote__card',
    /* Footer */
    '.site-footer__brand',
    '.site-footer__nav',
    '.site-footer__contact',
    '.site-footer__newsletter'
  ].join(',');

  /* Nada de aquí adentro se anima por su cuenta: o lo hace su contenedor, o
     tiene animación propia, o es interfaz que debe estar siempre disponible. */
  var FUERA = [
    '.hero',
    '.most-popular__slide',
    '.most-popular__quotes',
    '.our-production__slide',
    '.shop-categories__panel',
    '.hero__card-slide',
    '.nav-drawer',
    '.cart-drawer',
    '.mega-menu',
    '.site-header',
    '[hidden]'
  ].join(',');

  /* Las fotos entran además con un punto de zoom: es lo que las hace sentir
     "material" y no un bloque de texto más. */
  var ZOOM = '.team-grid__item,.photo-mosaic__item,.instagram__item,.facility__media,.beef-anatomy__panel,'
    + '.about-heritage__media,.about-sourcing__media,.about-member';

  var TOPE_ESCALON = 5; /* a partir del 6º hermano ya no se suma retardo */
  var pendientes = [];
  var observador = null;

  function preparar(raiz) {
    var nodos = Array.prototype.slice.call((raiz || document).querySelectorAll(LISTA));

    /* Fuera lo excluido y lo que ya esté preparado */
    nodos = nodos.filter(function (el) {
      return !el.closest(FUERA) && !el.classList.contains('reveal');
    });

    /* Si un elemento ya entra por su padre, no entra otra vez por su cuenta:
       si no, se anida un fundido dentro de otro y el hijo llega tarde y
       "parpadea" sobre un padre que ya está puesto. */
    nodos = nodos.filter(function (el) {
      return !nodos.some(function (otro) { return otro !== el && otro.contains(el); });
    });

    /* Escalonado por sección: el índice se cuenta dentro del ancestro de
       sección, así cada sección arranca su cuenta desde cero. */
    var cuenta = new Map();
    nodos.forEach(function (el) {
      var grupo = el.closest('section, footer') || document.body;
      var i = cuenta.get(grupo) || 0;
      cuenta.set(grupo, i + 1);
      el.style.setProperty('--reveal-i', Math.min(i, TOPE_ESCALON));
      el.classList.add('reveal');
      if (el.matches(ZOOM)) el.classList.add('reveal--zoom');
      pendientes.push(el);
      if (observador) observador.observe(el);
    });

    return nodos;
  }

  function mostrar(el) {
    el.classList.add('is-in');
    var i = pendientes.indexOf(el);
    if (i !== -1) pendientes.splice(i, 1);
  }

  function repasar() {
    pendientes.slice().forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) mostrar(el);
    });
  }

  function arrancar() {
    if (typeof IntersectionObserver !== 'function') return; /* sin observador no se esconde nada */

    observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        mostrar(entrada.target);
        observador.unobserve(entrada.target);
      });
    }, {
      /* -8% por abajo: la pieza arranca cuando ya asomó un poco, no al rozar
         el borde, que es cuando se nota falso. */
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.01
    });

    preparar(document);
    /* Red de seguridad. Repasa lo pendiente y revela SOLO lo que ya está en
       pantalla — no la página entera. La primera versión soltaba un
       `mostrarTodo()` a los 4s y eso se cargaba el efecto: a los 4 segundos de
       cargar, sin haber tocado el scroll, ya estaba todo revelado y no quedaba
       nada que ver al bajar (medido: 47 de 47 con el scroll en 0). Los casos
       que hay que cubrir son que el observador no llegue a disparar y que la
       pestaña vuelva de segundo plano, y para los dos basta con mirar quién
       cae dentro del viewport. */
    setTimeout(repasar, 1200);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) repasar();
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) repasar(); });
    /* Al cambiar de ancho pueden aparecer piezas que en el otro breakpoint
       estaban en display:none — las chips de la vaca, sin ir más lejos, miden 0
       en escritorio. Nacen ocultas y sin haber intersecado nunca, así que se
       repasa al terminar de redimensionar. */
    var reloj;
    window.addEventListener('resize', function () {
      clearTimeout(reloj);
      reloj = setTimeout(repasar, 200);
    }, { passive: true });

    /* Editor de temas: la sección repintada llega sin preparar. */
    document.addEventListener('shopify:section:load', function (e) {
      preparar(e.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
}());
